import CrudRepository from './CrudRepository'
export default class ServiceCentersRepository extends CrudRepository {
  constructor () {
    super('customerCare/api/centers/web/city')
  }
}
